import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incidents-rolle-berechtigungen-setzen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentsRolleBerechtigungenSetzenEffects {

    IncidentsRolleBerechtigungenSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENTS_ROLLE_BERECHTIGUNGEN_SETZEN),
        mergeMap((x: ac.PostIncidentsRolleBerechtigungenSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentsRolleBerechtigungenSetzen(x.incidentsRolleBerechtigungenRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentsRolleBerechtigungenSetzenErfolgreichAction(result, x.incidentsRolleBerechtigungenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentsRolleBerechtigungenSetzenFehlerAction(error, x.incidentsRolleBerechtigungenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
